import type {
  GlobalContent,
  PaymentMethod,
  CartSummary as TCartSummary,
} from "@wbly/data-storefront";
import { useStore } from "@nanostores/react";
import { DiscountForm } from "../DiscountForm/DiscountForm";
import { PaymentOptions } from "../PaymentOptions/PaymentOptions";
import { CartSummary } from "../CartSummary/CartSummary";
import { cartDetails } from "../../../pages/[locale]/cart/stores/details.store";
import { MentionMe } from "../MentionMe/MentionMe";
import { PaymentIcons } from "../PaymentIcons/PaymentIcons";
import styles from "./CartSidebar.module.css";

const { sidebar, paymentAndDiscount } = styles;

type CartSidebarProps = {
  staticContent: TCartSummary & GlobalContent;
  marketplace: string;
  locale: string;
  currency: string;
  payPalSdkUrl: string;
  mentionMeUrl: string;
  paymentMethods: PaymentMethod[];
  stripeKey: string;
  iso: string;
};

export function CartSidebar({
  staticContent,
  marketplace,
  locale,
  currency,
  payPalSdkUrl,
  mentionMeUrl,
  paymentMethods,
  stripeKey,
  iso,
}: CartSidebarProps) {
  const $cartDetails = useStore(cartDetails);
  const orderTotal = parseInt(
    $cartDetails?.data?.order?.totals_v2?.order.amount
  );

  if (!$cartDetails.data || $cartDetails.data.order.items.length === 0) {
    return null;
  }

  return (
    <div className={sidebar}>
      <CartSummary staticContent={staticContent} />

      {!staticContent.hidePaymentIcons && (
        <PaymentIcons paymentMethods={paymentMethods} />
      )}

      <div
        className={paymentAndDiscount}
        data-reverse={staticContent.positionDiscountFormFirst}
      >
        <PaymentOptions
          currency={currency}
          locale={locale}
          staticContent={staticContent}
          payPalSdkUrl={payPalSdkUrl}
          marketplace={marketplace}
          stripeKey={stripeKey}
          iso={iso}
          orderTotal={orderTotal}
        />
        <DiscountForm staticContent={staticContent} locale={locale} />
      </div>

      <MentionMe mentionMeUrl={mentionMeUrl} />
    </div>
  );
}
